
import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import GrantsApplicationPage from './grants-application-page';

import { Layout, MinMaxLayout } from '../../layouts';
import ApplicationStateHandler from "../../lib/applications/application-state-handler";
import ApplicationApi from "../../lib/applications/application-api";
import AlertManager from "../../managers/alert/alert-manager";
import {sanatize} from "../../lib/helpers/formatters";

class GrantsApplication extends Component {

    constructor(props) {
        super(props);

        this.state = {
            values: {},
            loaded : false,
            completed_sections : [],
            application : {}
        };
    }

    componentDidMount() {
        this.stateHandler = new ApplicationStateHandler();

        this.stateHandler.setOnStateUpdate((state, callback ) => {
            this.setState(state, () => {
                if(callback) {
                    callback();
                }
            });
        });

        this.getApplication();
    }

    getApplication() {
        new ApplicationApi().getApplication(this.props.applicationId).then(data => {

            this.setState({
                application : data
            }, () => {
                this.stateHandler.setStateFromApplication(this.state, data)
            });
        })
    }

    onSave() {
        const content = this.stateHandler.toArray(this.state);

        const params = {
            content: content,
            completed_sections: this.state.completed_sections
        }

        new ApplicationApi().update(this.state.application.id, params, (err) => this.handleErrors(err, 'Saving an application')).then(() => {
            AlertManager.success('Application Saved');
        });
    }

    handleErrors(err, msg) {
        if (err.length > 0) {
            AlertManager.error(err[0][0]);
        } else {
            AlertManager.error(err);
        }

        const error = new Error(msg);

        window.Bugsnag?.leaveBreadcrumb(msg, err);
        window.Bugsnag?.notify(error);
    }

    handleSubmit(finalParams) {
        const content = this.stateHandler.toArray(this.state);
        const app = new ApplicationApi();

        app.update(this.state.application.id, { content : content, completed_sections:  this.state.completed_sections }, (err) => this.handleErrors(err, 'Saving an application')).then(data => {
            app.submit(this.state.application.id, Object.assign({}, finalParams, {
                final_application_version_id : data.latest_application_versions[0].id
            }), (err) => this.handleErrors(err, 'Submitting an application')).then(response => {
                AlertManager.success('Application submitted');
                this.getApplication();

                document.querySelector('.content').scrollTo({top: 0, behavior: 'smooth'})
            });
        });
    }

    handleQuestionChange(sectionId, blockId, questionId, value) {

        this.stateHandler.setQuestionValueState(this.state,sectionId,blockId,questionId, value);
    }

    getQuestionValue(sectionId, blockId, questionId) {
        return this.stateHandler.getQuestionValue(this.state, sectionId, blockId, questionId);
    }

    handleSectionComplete(completed, sectionId) {

        if(completed === true) {
            this.stateHandler.completeSection(this.state, sectionId, () => {
                this.onSave();
            });
        }

        if(completed === false) {
            this.stateHandler.unCompleteSection(this.state, sectionId);
        }

    }



    render() {
        if (Object.keys(this.state.application).length == 0) return;

        return (
            <Layout>
                <MinMaxLayout main={
                    <GrantsApplicationPage
                        loaded={this.state.loaded}
                        onSubmit={this.handleSubmit.bind(this)}
                        onSectionComplete={this.handleSectionComplete.bind(this)}
                        completedSections={this.state.completed_sections}
                        application={this.state.application}
                        handleQuestionChange={this.handleQuestionChange.bind(this)}
                        getQuestionValue={this.getQuestionValue.bind(this)}
                        onSave={this.onSave.bind(this)}
                        getApplication={this.getApplication.bind(this)}
                    />}

                />
            </Layout>
        );
    }
}

const el = document.getElementById('grants-application');

if (el) {
    ReactDOM.render(<GrantsApplication applicationId={el.getAttribute('data-application-id')} />, el);
}
